import SundayPartner from './SundayPartner';

export default SundayPartner;
